<template>
    <div class="mobileApp itemview_wrapper">
        <div class="loading-spinner" v-if="is_loading">
            <base-spinner></base-spinner>
        </div>
        <div class="page_title"> 아이템</div>
        <div class="itemview_body" v-if="!is_loading">
            <div class="item_img">
                <div v-if="item.image" class="img_area">
                    <img :src="`/storage/${item.image}`">
                </div>
                <div v-else class="blank_img">
                    {{item.title}}
                </div>
            </div>

            <div class="item_info">
                <h1>{{item.title}}</h1>
                <div v-if="item.price>0" class="price">{{addCom(item.price)}}<span class="unit">원</span></div>
                <div v-else class="price">{{addCom(Math.abs(item.point))}} P</div>
                <!--지급 포인트 -->
                <div v-if="item.category ==='point'" class="givepoint">
                    <div>지급 포인트</div>
                    <div class="point">{{addCom(item.point)}}<img src="@/assets/imgs/icon_point.png"> </div>
                </div>

                <!--제한 사항 -->
                <div class="limit">

                </div>

                <!--포인트 상품 강조 -->
                <div v-if="item.category ==='point'" class="pointaccent">
                    레벨업 포인트 도달시 <strong>레벨업</strong> + <strong>추가 포인트</strong>
                </div>

                <!-- 부연 설명 -->
                <p>{{item.description}}</p>
                <div class="addCount">
                    <div class="addsub">
                        <button type="button" class="_sub" @click="decrease">
                            <span class="blind">수량 빼기</span>
                        </button>
                        <input type="text" class="_counter"  v-model.trim="counter" @keypress="ckCounter($event)">
                        <button type="button" class="_add" @click="increase">
                            <span class="blind">수량 추가</span>
                        </button>
                    </div>
                </div>

                <div class="total_price  getpoint" v-if="item.price>0">
                    <div class="title">총 상품 금액</div>
                    <div class="sum">총 수량 <span >{{counter}}</span>개 | <span class="total">{{addCom(getTotalPrice)}}<span class="unit">원</span> </span> </div>
                </div>
                <div class="total_price" v-else>
                    <div class="title">총 상품 포인트</div>
                    <div class="sum">총 수량 <span >{{counter}}</span>개 | <span class="total">{{addCom(getTotalPoint)}}<span class="unit">P</span> </span> </div>
                </div>

                <template v-if="item.category ==='point'" >
                    <div class="givepoint">
                        <div>지급 포인트</div>
                        <div class="point">{{addCom(getTotalPoint)}}<img src="@/assets/imgs/icon_point.png"> </div>
                    </div>
                </template>
                <template v-if="item.price >0" >
                    <div class="bankinfo">
                        <div>
                            예금주 (무통장 입금시 본인확인용)                            
                        </div>
                        <input type="text" v-model.trim="user_name" placeholder="예금주">
                        <!-- <select v-model="bank_name">
                           <option value="">-은행선택-</option>
                            <option
                                v-for="(bank,index) in banklists"
                                :key="index"
                                :value="`${bank}`"
                            >
                                {{ bank }}
                            </option>
                        </select>
                        <input type="text" v-model.trim="bank_num" placeholder="계좌번호"> -->
                    </div>
                    <div v-if="!formIsValid" class="alert-valid">
                        <div><span class="ic_alert"></span></div>
                        <div class="text">예금주를 입력해 주세요!!!</div>
                    </div>
                </template>

                <div class="btn_part">
                    <base-button mode="orange" @click="buyItem">구매하기</base-button>
                </div>
            </div>
        </div>

        <div class="add_info">
            <h1>아이템 구매 확인 사항</h1>
            <p>
                유료아이템<strong>[포인트 아이템, 닉네임변경권]</strong> 구매시 입금 계좌 안내<br>
                <span class="deposit_bank_info">기업은행 (주)더나은커뮤니티 114-178141-01-026</span>
            </p>
            <p>
            유료아이템인 <strong>[포인트 아이템, 닉네임변경권]</strong> 은 관리자 승인후 사용 하실수 있으며, 그 외 아이템은 구매후 바로 사용 하실 수 있습니다.<br>
            구매한 아이템은 마이페이지 구매내역에서 확인 하실수 있습니다.<br>
            </p>
            <p class="accent">
            아이템은 구매후 마이페이지 [구매내역]에서 사용하기를 하셔야 효력이 발생됩니다. 
            </p>
            
        </div>
    </div>
</template>
<script>
import { addCommas } from '@/utils/checkdata.js';
import { banklists } from '@/components/mixins/banklists.js';
import { auth } from '@/components/mixins/auth.js';

export default {
    name:'itemview',
    mixins:[ auth,banklists],
    props:['id'],
    data(){
        return{
            counter:1,
            totalPrice:0,
            totalPoint:0,
            user_name:null,
            bank_name:null,
            bank_num:null,
            formIsValid:true,
            is_loading:true,
        }
    },
    computed:{
        item:{
            get(){
                return this.$store.state.item.itemview;
            }
        },
        getTotalPrice(){
            return this.$store.state.item.itemview.price * this.counter;
        },
        getTotalPoint(){
            return Math.abs(this.$store.state.item.itemview.point * this.counter);
        },
    },
    mounted(){
        this.itemView();
    },
    methods: {
        async buyItem(){
            if(this.authCheck('isMobile') !==true)
            {
                return
            }
            //입력값 체크
            // if(this.item.price > 0 && (this.user_name===null || this.bank_name===null || this.bank_num ===null))
            if(this.item.price > 0 && this.user_name===null)
            {
                this.formIsValid =false;
                return;
            }
            const formData = {
                itemId:this.item.id,
                user_id:this.user.id,
                user_name:this.user_name,
                bank_name:this.bank_name,
                bank_num:this.bank_num,
                count:this.counter
            }
            try {
                const response = await this.$store.dispatch("item/itemBuy", formData)
                console.log(response); 
                if(response.itemBuy)
                {
                    this.$store.commit('updateUserPoint',response.user);    
                }
                this.$flashMessage.show({
                    type: response.itemBuy===false?"error":"info",
                    title: response.message,
                    message: response.message,
                });   
                           
            }catch(error){
                console.log(error);
               
            }

        },
        ckCounter(evt){
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        increase(){
            this.counter++;
        },
        decrease(){
            if(this.counter === 1)
            {
                alert('최소단위는 1개입니다.');
                return;
            }
            this.counter--;
        },
        addCom(val)
        {
            return addCommas(val);
        },
        async itemView() {
            const formData = {
                itemId:this.id
            }
            try {
                const response = await this.$store.dispatch("item/itemView", formData)
                //console.log(response);
                this.items = response.data;
                this.is_loading = false;
                //console.log("안나오는듯",this.postlists.data.length);
            }catch(error){
                console.log(error.response);
            }
            this.isLoading = false;
        },
    }

}
</script>
<style lang="scss" scoped>

@import '@/assets/scss/item_view';
.itemview_wrapper{
    background:white;     
    .itemview_body{        
        display: block;
        border: none;
        margin-top:20px;      
         .item_img{
            width:100%;
            min-height: calc( 100vh/3 );
            border-right: none;
             padding:0 !important;
        }
        .blank_img{
            width:100%;
            min-height: calc( 100vh/3 );
           
        }
        .item_info{           
            padding:0 20px 0 20px;
            width: 100%;
        }
    }
    .add_info{
        border: none !important;
    }
}
.ic_alert{    
    background: url(../../../assets/imgs/sp_account.png) no-repeat -60px 0; 
}

</style>
